import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.string.ends-with";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getModule } from "vuex-module-decorators";
import Navigation from '~/store/navigation';
import NavBarItem from '~/components/navigation/NavBarItem.vue';
import FormSelect from "~/components/validatableForm/FormSelect.vue";
import { namespace } from "vuex-class";
import { name as orders } from "~/store/orders";
import * as api from "~/utils/api";
var ORDERS = namespace(orders);

var NavBar = /*#__PURE__*/function (_Vue) {
  _inherits(NavBar, _Vue);

  var _super = _createSuper(NavBar);

  function NavBar() {
    _classCallCheck(this, NavBar);

    return _super.apply(this, arguments);
  }

  _createClass(NavBar, [{
    key: "created",
    value: function created() {
      this.navigationModule = getModule(Navigation, this.$store);
      this.navigationTree = this.navigationModule.sitemap;
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getCurrentOrders();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "show",
    value: function show(item) {
      if (!item.adminOnly) {
        return true;
      }

      return this.$auth.user.permissions.isAdminUser;
    }
  }, {
    key: "hoverMenu",
    value: function hoverMenu(event) {
      //add kt-menu__item--hover
      var drop_menu = event.target.parentElement.getElementsByClassName("drop_menu")[0];
      var drop_menus = document.getElementsByClassName("drop_menu");
    }
  }, {
    key: "getCurrentOrders",
    value: function () {
      var _getCurrentOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return api.ClientFactory.createApiClient().get('/orders').then(function (response) {
                  if (response.data.data != undefined) {
                    var JSONAPIDeserializer = require('ts-jsonapi').Deserializer;

                    var orderCollection = new JSONAPIDeserializer({
                      keyForAttribute: 'underscore_case'
                    }).deserialize(response.data);
                    orderCollection.forEach( /*#__PURE__*/function () {
                      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(order) {
                        return regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                if (!(order.status === 'subscription_payment_failed')) {
                                  _context2.next = 6;
                                  break;
                                }

                                _this.setFailedPaymentOrder(order);

                                _this.setFailedSubPaymentOrder(true);

                                _context2.next = 5;
                                return _this.getFailedPaymentAccountLock(order.id);

                              case 5:
                                return _context2.abrupt("return");

                              case 6:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      }));

                      return function (_x) {
                        return _ref.apply(this, arguments);
                      };
                    }());
                  }
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getCurrentOrders() {
        return _getCurrentOrders.apply(this, arguments);
      }

      return getCurrentOrders;
    }()
  }, {
    key: "getFailedPaymentAccountLock",
    value: function () {
      var _getFailedPaymentAccountLock = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(incrementId) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return api.ClientFactory.createApiClient().get('/subscription/failed/' + incrementId).then(function (response) {
                  if (response.data != undefined) {
                    var details = response.data;
                    debugger;
                    var orderIncrementId = details.incrementId;
                    var daysSinceLastUpdate = details.daysSinceLastUpdate;
                    var lockoutDays = parseInt(process.env.lockoutDays);

                    if (daysSinceLastUpdate > lockoutDays) {
                      var viewRoute = '/order/payment/' + orderIncrementId;

                      if (!_this2.$route.path.endsWith(orderIncrementId)) {
                        _this2.$router.push(viewRoute);
                      }
                    }
                  }
                });

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getFailedPaymentAccountLock(_x2) {
        return _getFailedPaymentAccountLock.apply(this, arguments);
      }

      return getFailedPaymentAccountLock;
    }()
  }]);

  return NavBar;
}(Vue);

__decorate([ORDERS.State('subscriptionPaymentFailed')], NavBar.prototype, "subscriptionPaymentFailed", void 0);

__decorate([ORDERS.State('failedPaymentOrder')], NavBar.prototype, "failedPaymentOrder", void 0);

__decorate([ORDERS.Action('setFailedPaymentOrder')], NavBar.prototype, "setFailedPaymentOrder", void 0);

__decorate([ORDERS.Action('setSubscriptionPaymentFailed')], NavBar.prototype, "setFailedSubPaymentOrder", void 0);

NavBar = __decorate([Component({
  components: {
    NavBarItem: NavBarItem,
    FormSelect: FormSelect
  }
})], NavBar);
export default NavBar;